let price = 0;

export function useAssortmentS3(assortmentContent) {
    if (assortmentContent.price_per_gb) {
        price = Number(assortmentContent.price_per_gb);
    }

    return { price };
}
